import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { getAuthorMetadata } from 'site-modules/shared/utils/editorial/author';
import { AuthorMetadata } from './author-metadata';

export function AllAuthorsMetadata({
  allAuthors = {
    author: DEFAULT_CONTENT,
    coAuthor: DEFAULT_CONTENT,
    editor: DEFAULT_CONTENT,
  },
  authorNameNoLink = null,
}) {
  const authors = [
    { metadata: getAuthorMetadata(allAuthors?.author), byline: 'by' },
    { metadata: getAuthorMetadata(allAuthors?.coAuthor), byline: 'by' },
    { metadata: getAuthorMetadata(allAuthors?.editor), byline: 'edited by' },
  ].filter(({ metadata }) => metadata?.name);

  return (
    <div className="all-authors-metadata">
      {authors.length ? (
        authors.map(({ metadata, byline }) => <AuthorMetadata key={metadata.name} {...metadata} byline={byline} />)
      ) : (
        <AuthorMetadata name={authorNameNoLink} rel="nofollow" />
      )}
    </div>
  );
}

AllAuthorsMetadata.propTypes = {
  allAuthors: PropTypes.shape({
    author: CmsEntities.Content,
    coAuthor: CmsEntities.Content,
    editor: CmsEntities.Content,
  }),
  authorNameNoLink: PropTypes.string,
};
